import { FallbackProps } from 'react-error-boundary';
import { Container } from 'yoso';
import { ErrorMessage } from '~/components/Error/Message/v2/ErrorMessage';
import { t } from '~/components/I18n';
import textBalloon from '~/components/Icon/textBalloon.png';
import { Section } from '~/components/Page/Section/Section';
import styles from './AdventureErrorFallback.module.scss';

export type AdventureErrorFallbackProps = FallbackProps;
export const AdventureErrorFallback = ({ error }: AdventureErrorFallbackProps) => {
  switch (error.message) {
    case 'EMPTY':
      return (
        <Section className={styles.root}>
          <Container margin="auto" className={styles.body}>
            <div />
            <ErrorMessage
              title={t('citizen_adventure_empty')}
              description={t('citizen_adventure_empty_desc')}
              icon={<img className="icon" src={textBalloon} alt="empty" />}
            />
            <div />
          </Container>
        </Section>
      );
    default:
      throw error;
  }
};
